import React, {Component} from 'react';
import SearchForm from "./components/SearchForm";
import BackEnd from '../../../backend/BackEnd';
import './AdvertList.css'
import AdvertCard from "./components/AdvertCard";
import Pager from "../../../controls/Pager";

class AdvertList extends Component {
    static propTypes = {};
    static defaultProps = {
        pageSize: 8
    };
    state = {
        isLoading: false,
        pageIndex: 0,
        items: [],
        totalCount: 0,
        counters: null
    };
    searchCriteria = {showAllProducts: true};
    searchEndpoint = new BackEnd.Adverts.Search({
        start: () => this.setState({isLoading: true}),
        end: () => this.setState({isLoading: false})
    });

    async componentWillMount() {
        await this.search();
    }

    render() {
        const loadingSpinner = <div className="text-center m-t-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>;

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>Объявления</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <SearchForm counters={this.state}
                                    adertsTypeFilter={this.props.match.params.filter}
                                    onChange={criteria => this.updateCriteria(criteria)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <span className="">Найдено {this.state.totalCount}</span>
                                </div>
                                <div className="col-md-8">
                                    <div className="pull-right">
                                        <Pager className="p-a-0 m-a-0" size="sm"
                                               pageSize={this.props.pageSize}
                                               pageIndex={this.state.pageIndex}
                                               totalCount={this.state.totalCount}
                                               onChange={pageIndex => this.updatePageIndex(pageIndex)}/>
                                    </div>
                                </div>
                            </div>
                        </SearchForm>
                    </div>
                    <div className="col-lg-6">
                        <div className="panel box" style={{position: 'static'}}>
                            <div className="box-row">
                                <div className="box-cell p-x-2 p-y-1 bg-black text-xs-center font-size-11 font-weight-semibold">
                                    <i className="fa fa-exclamation-circle"/>&nbsp;&nbsp;Важная информация
                                </div>
                            </div>
                            <div className="box-row">
                                <div className="panel-body">
                                    <h4 className="m-t-1 m-b-3">Гарантированный выкуп:</h4>
                                    <p className="font-size-14 m-b-0">
                                        <i className="fa fa-asterisk"/> б/у Евро 2 сорт – 300 руб. с НДС и доставкой по МО
                                        <br/>
                                        <i className="fa fa-asterisk"/> б/у 2 сорт 1200х800 – 180 руб. с НДС и доставкой по МО
                                        <br/>
                                        <i className="fa fa-asterisk"/> новые поддоны 1 сорт 1200х800 – 305 с НДС и доставкой по МО
                                        <br/>
                                        Заявки направляйте на почту <strong><a href="mailto:sales@rcc-rus.ru">info@netpal.ru</a></strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        {
                            this.state.isLoading
                                ? loadingSpinner
                                : this.state.items.map(advert =>
                                    <AdvertCard onRemove={() => this.search()} key={advert.advertId} data={advert}/>)
                        }
                    </div>
				</div>
				<div className="row">
					<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
						<Pager className="p-a-0 m-a-0" size="sm"
							pageSize={this.props.pageSize}
							pageIndex={this.state.pageIndex}
							totalCount={this.state.totalCount}
							onChange={pageIndex => this.updatePageIndex(pageIndex)} />
					</div>
				</div>
            </div>
        );
    }

    async updateCriteria(criteria) {
        this.setState({pageIndex: 0});
        await this.search(criteria, 0);
    }

    async updatePageIndex(pageIndex) {
        this.setState({pageIndex});
        await this.search(this.searchCriteria, pageIndex);
    }

    async search(criteria = this.searchCriteria, pageIndex = this.state.pageIndex) {
        this.searchCriteria = criteria;

        let searchResult = await this.searchEndpoint.call({
            dto: {
                ...criteria,
                paging: {
                    pageIndex: pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState({...searchResult});
    }
}

export default AdvertList;


// WEBPACK FOOTER //
// ./src/pages/Adverts/AdvertList/AdvertList.js